import { CardSection, CardHeader } from '@europrocurement/flexy-components';
import * as React from 'react';
import { PrescriberTabProps } from './types';

const Billing: React.FunctionComponent<PrescriberTabProps> = function () {
    const cardHeader = (
        <CardHeader
            title="Comptabilité"
            border={false}
        />
    );
    return <CardSection header={cardHeader}>Comptabilité</CardSection>;
};

export default Billing;
